export default class UnknownSwitchCaseError extends Error {
  constructor(
    message = 'You should provide a valid value to a switch statement or implement a default handler',
  ) {
    super(message);
    this.name = 'UnknownSwitchCaseError';
  }
}
